import FlavorSummaryChartGroup from './FlavorSummaryChartGroup';
export default FlavorSummaryChartGroup;